import React from 'react';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative z-10 border-t border-slate-800 bg-black/40 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-1">
            <div className="mb-3">
              <img src="/logo.png" alt="BatchTools" className="h-8 w-auto object-contain object-left" />
            </div>
            <p className="text-xs text-slate-500 leading-relaxed">
              Free batch image editor for estate agents and property marketers. Resize, watermark and rename in seconds.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-cyan-400 uppercase tracking-wider mb-3">Features</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>Batch Resize</li>
              <li>Logo / Watermark</li>
              <li>File Renaming</li>
              <li>ZIP Download</li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-cyan-400 uppercase tracking-wider mb-3">ReHub Suite</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>
                <a href="https://imagemotion.rehub.studio" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">
                  ImageMotion
                </a>
              </li>
              <li>
                <a href="https://photoclear.rehub.studio" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">
                  Photoclear
                </a>
              </li>
              <li>
                <a href="https://planos.rehub.studio" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">
                  Planos
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-cyan-400 uppercase tracking-wider mb-3">Company</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>
                <a href="https://hub.rehub.studio" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">
                  ReHub Studio
                </a>
              </li>
              <li>
                <a href="https://hub.rehub.studio/#/contact" className="hover:text-cyan-400 transition-colors">
                  Contact
                </a>
              </li>
              <li>
                <a href="https://rehub.studio/terms" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">
                  Terms
                </a>
              </li>
              <li>
                <a href="https://rehub.studio/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">
                  Privacy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-slate-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-slate-600">
            &copy; {year} ReHub Studio. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-[11px] text-slate-600">
            <span>Part of the ReHub Suite</span>
            <span className="text-slate-700">&middot;</span>
            <span>Free to use</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
